<template>
  <v-card outlined class="card-wrapper" color="grey lighten-1"></v-card>
</template>

<script>
export default {
  name: "BasePostCardLoading"
};
</script>

<style scoped>
.card-wrapper {
  padding-top: 133.33%;
  width: 100%;
}
</style>
